/**
 * The GitHub organisation the home page cards search in. Pull requests in
 * personal repositories and other organisations are left out.
 */
export const GITHUB_ORG = 'integromat';

/** The signed-in user's open pull requests in the organisation: the query of
 * Roadie's HomePageYourOpenPullRequestsCard, scoped. The old "Your open pull
 * requests" card and the "Your work" card both search with it. */
export const OPEN_PULL_REQUESTS_QUERY = `is:open is:pr author:@me archived:false org:${GITHUB_ORG}`;
